export interface Transaction {
  id: number;
  account_id: number;
  date: string;
  action: 'Deposit' | 'Draft' | 'Check' | 'Cash' | 'Memo';
  payee: string;
  payment: number | null;
  deposit: number | null;
  notes: string | null;
  cleared: boolean;
  is_eom: boolean;
  created_at: string;
  updated_at: string;
}

export interface TransactionInput {
  date: string;
  action: string;
  payee: string;
  payment: number | null;
  deposit: number | null;
  notes: string;
  is_eom?: boolean;
}

export interface Account {
  id: number;
  user_id: number;
  name: string;
  starting_balance: number;
  private: boolean;
  owner_name?: string;
  owner_email?: string;
  access_type?: string;
  created_at: string;
  updated_at: string;
}

export interface PayeeSuggestion {
  payee: string;
  action: string;
  payment: number | null;
  deposit: number | null;
  last_used: string;
}

export type ActionType = 'Deposit' | 'Draft' | 'Check' | 'Cash' | 'Memo';

export const ACTION_OPTIONS: ActionType[] = ['Deposit', 'Draft', 'Check', 'Cash', 'Memo'];
